import React from "react";
import "./signup.css";
import logo from "../assets/img/logo.png";
import firebase from "firebase";
import Loader from '../component/loader'

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loader:false
    };
  }
  login(e) {
    e.preventDefault();
    const { email, password } = this.state;
    let obj = {
      email,
      password,
    };
    firebase
    .auth()
    .signInWithEmailAndPassword(obj.email, obj.password)
    .then((user) => {
      this.setState({loader:true})
      this.props.history.push('/admin')
      this.setState({loader:false})
      })
      .catch((error) => {
        var errorMessage = error.message;
        alert(errorMessage);
      });
  }
  render() {
    return (
      <div
      style={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        height: "100vh",
      }}
      >
      {this.state.loader?<Loader />:null}
        <div className="login bg-white shadow rounded p-5">
          <img src={logo} width="160" />
          <h2>Login</h2>
          <form onSubmit={(e) => this.login(e)}>
            <div className="py-3">
              <label className="lab">Email</label>
              <input
                onChange={(e) => this.setState({ email: e.target.value })}
                placeholder="example@gmail.com"
                type="email"
                className="inp"
              />
            </div>
            <div className="py-3">
              <label className="lab">Password</label>
              <input
                onChange={(e) => this.setState({ password: e.target.value })}
                placeholder="Password"
                type="password"
                className="inp"
              />
            </div>
            <div className="py-3">
              <button className="customBtn btn-block">Login</button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
